import { Injectable, signal, computed, DestroyRef, inject } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private breakpointObserver = inject(BreakpointObserver);
  private verticalLayout = signal(false);
  private destroyRef = inject(DestroyRef);

  isVerticalLayout = computed(() => this.verticalLayout());

  constructor() {
    this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.setVerticalLayout());
  }

  private setVerticalLayout() {
    const isVertical =
      this.breakpointObserver.isMatched(Breakpoints.XSmall) || this.breakpointObserver.isMatched(Breakpoints.Small);
    this.verticalLayout.set(isVertical);
  }
}
